import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: '#154D93',
        stroke: '#51B5E5',
    },

    st1: {
        fill: '#022958',
    },

    st2: {
        clipPath: 'url(#SVGID_2_)',
    },

    st3: {
        fill: '#F28C00',
    },

    st4: {
        fill: '#EE7624',
    },

    st5: {
        fill: '#009BE0',
    },

    st6: {
        fill: '#01BFD7',
    },

    st7: {
        fill: '#F9BF01',
    },

    st8: {
        fill: '#76BD22',
    },

    st9: {
        fill: '#00A8E2',
    },

    st10: {
        fill: 'none',
    },

    st11: {
        fill: '#FFFFFF',
    },

    st12: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st13: {
        fontSize: '15px',
    },

}));
